module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst customer = attributes.customer || {}\nconst customerContact = attributes.customerContact || {}\nconst parts = [], contactParts = []\nif(customer.customerID){\nif(customer.companyName){\nparts.push(customer.companyName)\n}\n}\nif(customerContact.customerContactID){\nif(customerContact.title){\ncontactParts.push(customerContact.title)\n}\nif(customerContact.firstname){\ncontactParts.push(customerContact.firstname)\n}\nif(customerContact.lastname){\ncontactParts.push(customerContact.lastname)\n}\nif(customerContact.capacity){\ncontactParts.push(`(${customerContact.capacity})`)\n}\nif(contactParts.length > 0){\ncontactParts.unshift('/')\nparts.push(contactParts.join(' '))\n}\n}\nif(parts.length < 1){\nparts.push('-')\n}\n%><div><%\n%><%= parts.join(' ') %><%\n%></div>"
  , __filename = "components/templates/office/trips/tableFields/customer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const customer = attributes.customer || {}
const customerContact = attributes.customerContact || {}
const parts = [], contactParts = []
if(customer.customerID){
if(customer.companyName){
parts.push(customer.companyName)
}
}
if(customerContact.customerContactID){
if(customerContact.title){
contactParts.push(customerContact.title)
}
if(customerContact.firstname){
contactParts.push(customerContact.firstname)
}
if(customerContact.lastname){
contactParts.push(customerContact.lastname)
}
if(customerContact.capacity){
contactParts.push(`(${customerContact.capacity})`)
}
if(contactParts.length > 0){
contactParts.unshift('/')
parts.push(contactParts.join(' '))
}
}
if(parts.length < 1){
parts.push('-')
}

    ; __line = 33
    ; __append("<div>")
    ; 

    ; __line = 34
    ; __append(escapeFn( parts.join(' ') ))
    ; 

    ; __line = 35
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/trips/tableFields/customer.ejs

}